<script>
  import Keyboard from "./Keyboard.svelte";
  import { save } from "./save-svg.js";

  let octaveWidth = 161;
  let blackKeyHeight = 80;
  let whiteKeyHeight = 120;
  let svg;

  function reset() {
    octaveWidth = 161;
    blackKeyHeight = 80;
    whiteKeyHeight = 120;
  }
</script>

<main>
  <h1>Piano Keyboard Math</h1>

  <blockquote cite="https://www.mathpages.com/home/kmath043.htm">
    If you've ever looked closely at a piano keyboard you may have noticed that
    the widths of the white keys are not all the same at the back ends (where
    they pass between the black keys). Of course, if you think about it for a
    minute, it's clear they couldn't possibly all be the same width, assuming
    the black keys are all identical (with non-zero width) and the white keys
    all have equal widths at the front ends, because the only simultaneous
    solution of 3W=3w+2b and 4W=4w+3b is with b=0.

    <a href="https://www.mathpages.com/home/kmath043.htm"
      >Read more about the math</a
    >
  </blockquote>

  <div>
    <label for="octave_width">Octave Width</label>
    <input id="octave_width" type="number" bind:value={octaveWidth} />
  </div>
  <div>
    <label for="black_keys">Black Key Height</label>
    <input id="black_keys" type="number" bind:value={blackKeyHeight} />
  </div>
  <div>
    <label for="white_keys">White Key Height</label>
    <input id="white_keys" type="number" bind:value={whiteKeyHeight} />
  </div>
  <div>
    <button on:click={() => save(svg)}>Save SVG</button>
    <button on:click={reset}>Reset</button>
  </div>

  <Keyboard {octaveWidth} {blackKeyHeight} {whiteKeyHeight} bind:svg />

  <a
    href="https://github.com/naomiaro/keyboard-math"
    class="github-corner"
    aria-label="View source on GitHub"
    ><svg
      width="80"
      height="80"
      viewBox="0 0 250 250"
      style="
        fill: #151513;
        color: #fff;
        position: absolute;
        top: 0;
        border: 0;
        right: 0;
      "
      aria-hidden="true"
    >
      <path d="M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z" />
      <path
        d="M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2"
        fill="currentColor"
        style="transform-origin: 130px 106px"
        class="octo-arm"
      />
      <path
        d="M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z"
        fill="currentColor"
        class="octo-body"
      /></svg
    ></a
  >
</main>

<style>
  blockquote {
    background: #f9f9f9;
    border-left: 10px solid #ccc;
    margin: 1.5em 10px;
    padding: 0.5em 10px;
    quotes: "\201C""\201D""\2018""\2019";
    max-width: 600px;
  }
  blockquote:before {
    color: #ccc;
    content: open-quote;
    font-size: 4em;
    line-height: 0.1em;
    margin-right: 0.25em;
    vertical-align: -0.4em;
  }
</style>
